import clsx from 'clsx';
import {ProductCategories} from '../../../types';
import {IoChevronDownOutline} from 'react-icons/io5';
import {Link} from '@shopify/hydrogen';

type Props = {
  category: ProductCategories;
  handleWorkType: any;
  workType: string;
  onClose: any;
  handleReset: any;
};

export default function ProductsCategories({
  category,
  handleWorkType,
  workType,
  onClose,
  handleReset,
}: Props) {
  const isVisible = workType === category._key ? true : false;

  const mainCategory = category.links[0];
  const subCategories = category.links.slice(1);

  return (
    <div className="select-none">
      <div
        className={clsx(
          'flex cursor-pointer uppercase hover:text-main',
          workType === category._key && 'text-main',
        )}
        onClick={
          isVisible
            ? () => handleWorkType('') + handleReset()
            : () => handleWorkType(category._key) + handleReset()
        }
      >
        {category.title}
        <span className="inline">
          <IoChevronDownOutline
            className={clsx('ml-fontSpace', isVisible ? 'rotate-180' : '')}
            size={16}
          />
        </span>
      </div>
      {isVisible && (
        <ul className="my-20 uppercase">
          {subCategories.map((link) => (
            <li key={link.slug}>
              <Link to={link.slug} onClick={onClose} className='link--nav'>
                {link.title}
              </Link>
            </li>
          ))}
          <li>
            <Link to={mainCategory.slug} onClick={onClose} className='link--nav'>
              All {mainCategory.title}
            </Link>
          </li>
        </ul>
      )}
    </div>
  );
}
